module.exports = __webpack_public_path__ + "static/media/weather app.0fba7761.png";